// extracted by mini-css-extract-plugin
export default {"remove":"Icon--remove---jIRX","info":"Icon--info--s917e"};